import { DataTable } from "@marketplace/ui/data-table";

import type { TransactionHistoryListItem } from "../../dtos/get-transaction-history-list-response-dto";
import { useTransactionHistoryListTableColumns } from "../../hooks/use-transaction-history-list-table-columns";

type TransactionHistoryTableProps = {
  records: TransactionHistoryListItem[];
};

export const TransactionHistoryTable: React.FC<
  TransactionHistoryTableProps
> = ({ records }) => {
  const { columns } = useTransactionHistoryListTableColumns();

  return <DataTable minHeight={10} columns={columns} records={records} />;
};
